import { CompanyBean } from 'common/api/api'
import { dictionaryApi } from 'common/api/entitiesApi'
import { LabelValue, ReloadableSelector } from 'common/components/reloadable/ReloadableSelector'
import React, { FC } from 'react'

interface Props {
  onChange: (value: string[] | undefined) => void
  value?: string[]
  style?: React.CSSProperties
  disabled?: boolean
  placeholder?: string
}

export const IspOrganizationSelector: FC<Props> = ({ value, onChange, style, disabled, placeholder }: Props) => {
  function ispOrganizationToLabelValue(ispOrganization: CompanyBean) {
    return { value: ispOrganization.name, label: ispOrganization.name } as LabelValue<string>
  }

  function loadIspOrganizations(values: string[]) {
    if (values && values.length > 0) {
      return dictionaryApi.companyGet(values).then((result) => result.map(ispOrganizationToLabelValue))
    } else {
      return Promise.resolve([])
    }
  }

  function searchIspOrganizations(search: string, selectedValues: string[], size: number, page: number) {
    return dictionaryApi
      .companySearch(search, size, page, selectedValues)
      .then((result) => result.map(ispOrganizationToLabelValue))
  }

  return (
    <ReloadableSelector
      value={value}
      onChange={onChange}
      size={100}
      style={style}
      loadValues={loadIspOrganizations}
      loadOptions={searchIspOrganizations}
      placeholder={placeholder}
      disabled={disabled}
      errorText="Can't load ISP / organizations"
      multiple
    />
  )
}
